"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMagicLink = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

function useMagicLink(resource) {
  var _react_1$default$useM = react_1.default.useMemo(function () {
    return resource.createMagicLinkFlow();
  }, [resource]),
      startMagicLinkFlow = _react_1$default$useM.startMagicLinkFlow,
      cancelMagicLinkFlow = _react_1$default$useM.cancelMagicLinkFlow;

  react_1.default.useEffect(function () {
    return cancelMagicLinkFlow;
  }, []);
  return {
    startMagicLinkFlow: startMagicLinkFlow,
    cancelMagicLinkFlow: cancelMagicLinkFlow
  };
}

exports.useMagicLink = useMagicLink;